import type { PropsWithChildren } from "react";

import styled from "styled-components";

const Shell = styled.span<{ $display: "block" | "inline-flex" }>`
    position: relative;
    isolation: isolate;
    display: ${({ $display }) => $display};
    width: ${({ $display }) => ($display === "block" ? "100%" : "auto")};
    cursor: not-allowed;
`;

const InertSubtree = styled.span`
    display: block;
    pointer-events: none;
`;

const PointerCapture = styled.span`
    position: absolute;
    inset: 0;
    z-index: 1000;
    cursor: not-allowed;
    pointer-events: auto;
`;

interface IPreviewInteractionBlockerProps extends PropsWithChildren {
    display?: "block" | "inline-flex";
    "data-automation"?: string;
}

export const PreviewInteractionBlocker = ({
    children,
    display = "block",
    "data-automation": dataAutomation = "preview-interaction-blocker",
}: IPreviewInteractionBlockerProps) => (
    <Shell
        $display={display}
        data-automation={dataAutomation}
    >
        <InertSubtree inert>{children}</InertSubtree>
        <PointerCapture
            aria-hidden="true"
            data-automation={`${dataAutomation}-pointer-capture`}
        />
    </Shell>
);
